import type React from 'react';

interface CheckboxProps {
  label?: string;
  checked: boolean;
  className?: string;
  id?: string;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  id,
  onChange,
  className = '',
  disabled = false,
}) => {
  return (
    <label
      className={`group flex cursor-pointer items-center space-x-3 ${
        disabled ? 'cursor-not-allowed opacity-60' : ''
      }`}
    >
      <div className="relative h-5 w-5">
        <input
          id={id}
          type="checkbox"
          className={`h-5 w-5 cursor-pointer appearance-none rounded-md border border-gray-300 checked:border-transparent disabled:opacity-60 dark:border-gray-700 ${className} hover:border-[color:var(--color-brand-primary)] focus:border-[color:var(--color-brand-primary)] focus:ring-1 focus:ring-[color:var(--color-brand-primary)]/10 focus:outline-none dark:focus:border-[color:var(--color-brand-primary)] dark:focus:ring-[color:var(--color-brand-primary)]/10`}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        {checked && (
          <svg
            className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
              stroke="var(--color-brand-primary)"
              strokeWidth="1.94437"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {disabled && (
          <svg
            className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
              stroke="#E4E7EC"
              strokeWidth="2.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      {label && (
        <span className="text-sm font-medium text-gray-800 dark:text-gray-200">{label}</span>
      )}
    </label>
  );
};

export default Checkbox;
